import(/* webpackMode: "eager" */ "/workspace/purple-ventures/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/purple-ventures/src/components/ui/separator.tsx");
